import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Career.css';

const Career = () => {
  const navigate = useNavigate();


  // Add language support state variables
  const [currentLanguage, setCurrentLanguage] = useState('english');
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);




  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobile: '',
    panCard: null,
    aadhaarFront: null,
    aadhaarBack: null,
    profilePhoto: null,
    position: '',
    experience: '',
    currentCompany: '',
    currentCTC: '',
    expectedCTC: '',
    noticePeriod: '',
    coverLetter: '',
    linkedin: '',
    portfolio: '',
    additionalDocuments: [],
    terms: false
  });
  const [resumeFile, setResumeFile] = useState(null);
  const [profilePhotoFile, setProfilePhotoFile] = useState(null);
  const [offerLetterFile, setOfferLetterFile] = useState(null);
  const [panCardFile, setPanCardFile] = useState(null);
  const [aadhaarFrontFile, setAadhaarFrontFile] = useState(null);
  const [aadhaarBackFile, setAadhaarBackFile] = useState(null);
  const [profilePhotoPreview, setProfilePhotoPreview] = useState('');
  const [fileName, setFileName] = useState('');
  const [offerLetterFileName, setOfferLetterFileName] = useState('');
  const [panCardFileName, setPanCardFileName] = useState('');
  const [aadhaarFrontFileName, setAadhaarFrontFileName] = useState('');
  const [aadhaarBackFileName, setAadhaarBackFileName] = useState('');
  const [additionalDocs, setAdditionalDocs] = useState([]);
  const [salarySlips, setSalarySlips] = useState([
    { id: Date.now(), month: '', file: null, fileName: '' }
  ]);
  const [formMessage, setFormMessage] = useState({ text: '', type: '' });
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState('');
  const [loading, setLoading] = useState(false);


   // Translations object
  const translations = {
    english: {
      logo: 'FinLink',
      navHome: 'Home',
      navProducts: 'Products',
      navAbout: 'About us',
      navDsa: 'Become Partner',
      navFaq: 'FAQ',
      navContact: 'Contact',
      navCareer: 'Career with us',
      navHelp: 'Help Desk',
      partnerButton: 'Login',
      applyButton: 'Become DSA'
    },
    hindi: {
      logo: 'फिनलिंक',
      navHome: 'होम',
      navProducts: 'उत्पाद',
      navAbout: 'हमारे बारे में',
      navDsa: 'भागीदार बनें',
      navFaq: 'सामान्य प्रश्न',
      navContact: 'संपर्क करें',
      navCareer: 'करियर हमारे साथ',
      navHelp: 'हेल्प डेस्क',
      partnerButton: 'लॉगिन',
      applyButton: 'डीएसए बनें'
    },
    gujarati: {
      logo: 'ફિનલિંક',
      navHome: 'હોમ',
      navProducts: 'ઉત્પાદનો',
      navAbout: 'અમારા વિશે',
      navDsa: 'ભાગીદાર બનો',
      navFaq: 'પ્રશ્નો-જવાબો',
      navContact: 'સંપર્ક કરો',
      navCareer: 'કારકિર્દી અમારી સાથે',
      navHelp: 'હેલ્પ ડેસ્ક',
      partnerButton: 'લૉગિન',
      applyButton: 'DSA બની જાઓ'
    }
  };

  const t = translations[currentLanguage];


  const departments = [
    { id: 'all', name: 'All Departments' },
    { id: 'sales', name: 'Sales & Business' },
    { id: 'operations', name: 'Operations' },
    { id: 'finance', name: 'Finance' },
    { id: 'support', name: 'Customer Support' }
  ];

  const jobOpenings = [
    { id: 1, title: 'Loan Sales Executive', department: 'sales', tag: '🔥 Hot Opening', location: 'Mumbai, Delhi, Bangalore', experience: '1-3 years', salary: '₹3L - ₹6L', description: 'Generate leads, meet potential clients, and convert them into loan customers. Achieve monthly sales targets.' },
    { id: 2, title: 'Relationship Manager', department: 'sales', tag: '💼 Managerial', location: 'All Major Cities', experience: '3-5 years', salary: '₹6L - ₹12L', description: 'Manage banking relationships, grow portfolio, and ensure customer satisfaction for high-value clients.' },
    { id: 3, title: 'Business Development Manager', department: 'sales', tag: '🚀 Leadership', location: 'PAN India', experience: '5-8 years', salary: '₹10L - ₹20L', description: 'Develop business strategies, manage team of executives, and drive overall business growth.' },
    { id: 4, title: 'Operations Executive', department: 'operations', tag: '📋 Operations', location: 'Mumbai HQ', experience: '1-3 years', salary: '₹2.5L - ₹4.5L', description: 'Handle loan processing, documentation, and ensure smooth operations of all loan applications.' },
    { id: 5, title: 'Credit Analyst', department: 'finance', tag: '💰 Finance', location: 'Mumbai HQ', experience: '2-4 years', salary: '₹4L - ₹8L', description: 'Analyze credit applications, assess risk, and make recommendations for loan approvals.' },
    { id: 6, title: 'Customer Support Executive', department: 'support', tag: '👥 Support', location: 'Work From Home', experience: '0-2 years', salary: '₹2L - ₹3.5L', description: 'Handle customer queries, provide support for loan applications, and ensure customer satisfaction.' }
  ];

  const benefits = [
    { icon: 'fas fa-trophy', title: 'Competitive Salary', description: 'Industry-best compensation with performance bonuses, incentives, and annual appraisals' },
    { icon: 'fas fa-chart-line', title: 'Rapid Growth', description: 'Clear career progression with promotions every 12-18 months based on performance' },
    { icon: 'fas fa-graduation-cap', title: 'Training & Development', description: 'Comprehensive training programs, workshops, and certifications fully sponsored by company' },
    { icon: 'fas fa-heartbeat', title: 'Health & Wellness', description: 'Health insurance for you and your family, wellness programs, and regular health checkups' },
    { icon: 'fas fa-plane', title: 'Work-Life Balance', description: 'Flexible working hours, work from home options, and generous paid time off policy' },
    { icon: 'fas fa-award', title: 'Recognition & Rewards', description: 'Monthly awards, performance bonuses, employee of the year awards with international trips' }
  ];

  const filteredJobs = selectedDepartment === 'all' ? jobOpenings : jobOpenings.filter(job => job.department === selectedDepartment);

  const handleApplyClick = (jobTitle) => {
    setFormData(prev => ({ ...prev, position: jobTitle }));

    const applicationSection = document.querySelector('.career-application-section');
    if (applicationSection) {
      applicationSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    setTimeout(() => {
      const positionSelect = document.getElementById('position');
      if (positionSelect) {
        positionSelect.focus();
        positionSelect.style.borderColor = '#6366f1';
        positionSelect.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.2)';
        setTimeout(() => {
          positionSelect.style.borderColor = '';
          positionSelect.style.boxShadow = '';
        }, 2000);
      }
    }, 500);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setResumeFile(null);
      setFileName('');
      return;
    }

    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only PDF, DOC, or DOCX files for resume');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setErrorModalMessage('Resume file size must be less than 5MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setResumeFile(file);
    setFileName(`Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);
  };

  const handleOfferLetterChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setOfferLetterFile(null);
      setOfferLetterFileName('');
      return;
    }

    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only PDF, DOC, or DOCX files for offer letter');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setErrorModalMessage('Offer letter file size must be less than 5MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setOfferLetterFile(file);
    setOfferLetterFileName(`Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);
  };

  const handlePanCardChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setPanCardFile(null);
      setPanCardFileName('');
      setFormData(prev => ({ ...prev, panCard: null }));
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only JPG or PNG images for PAN card');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setErrorModalMessage('PAN card image must be less than 2MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setPanCardFile(file);
    setFormData(prev => ({ ...prev, panCard: file.name }));
    setPanCardFileName(`Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);
  };

  const handleAadhaarFrontChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setAadhaarFrontFile(null);
      setAadhaarFrontFileName('');
      setFormData(prev => ({ ...prev, aadhaarFront: null }));
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only JPG or PNG images for Aadhaar');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setErrorModalMessage('Aadhaar image must be less than 2MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setAadhaarFrontFile(file);
    setFormData(prev => ({ ...prev, aadhaarFront: file.name }));
    setAadhaarFrontFileName(`Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);
  };

  const handleAadhaarBackChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setAadhaarBackFile(null);
      setAadhaarBackFileName('');
      setFormData(prev => ({ ...prev, aadhaarBack: null }));
      return;
    }

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only JPG or PNG images for Aadhaar');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setErrorModalMessage('Aadhaar image must be less than 2MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setAadhaarBackFile(file);
    setFormData(prev => ({ ...prev, aadhaarBack: file.name }));
    setAadhaarBackFileName(`Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`);
  };

  const captureFromCamera = () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setErrorModalMessage('Camera not supported in your browser');
      setShowErrorModal(true);
      return;
    }

    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        const video = document.createElement('video');
        video.srcObject = stream;
        video.play();
        
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        
        video.onloadedmetadata = () => {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          
          setTimeout(() => {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            stream.getTracks().forEach(track => track.stop());
            
            canvas.toBlob((blob) => {
              const file = new File([blob], 'profile-photo.jpg', { type: 'image/jpeg' });
              setProfilePhotoFile(file);
              setFormData(prev => ({ ...prev, profilePhoto: 'profile-photo.jpg' }));
              setProfilePhotoPreview(URL.createObjectURL(blob));
              setFormMessage({ text: 'Profile photo captured successfully!', type: 'success' });
            }, 'image/jpeg');
          }, 1000);
        };
      })
      .catch((error) => {
        setErrorModalMessage('Error accessing camera: ' + error.message);
        setShowErrorModal(true);
      });
  };

  // Additional Documents Functions
  const addAdditionalDocument = () => {
    const newDoc = {
      id: Date.now(),
      type: '',
      file: null,
      fileName: ''
    };
    setAdditionalDocs([...additionalDocs, newDoc]);
  };

  const removeAdditionalDocument = (id) => {
    setAdditionalDocs(additionalDocs.filter(doc => doc.id !== id));
  };

  const handleAdditionalDocTypeChange = (id, value) => {
    setAdditionalDocs(additionalDocs.map(doc => 
      doc.id === id ? { ...doc, type: value } : doc
    ));
  };

  const handleAdditionalDocFileChange = (id, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only PDF, DOC, DOCX, JPG or PNG files for additional documents');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setErrorModalMessage('Additional document file size must be less than 5MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setAdditionalDocs(additionalDocs.map(doc => 
      doc.id === id ? { ...doc, file, fileName: `Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)` } : doc
    ));
  };

  // Salary Slips Functions
  const addSalarySlip = () => {
    if (salarySlips.length >= 6) return;
    
    const newSlip = {
      id: Date.now(),
      month: '',
      file: null,
      fileName: ''
    };
    setSalarySlips([...salarySlips, newSlip]);
  };

  const removeSalarySlip = (id) => {
    if (salarySlips.length <= 1) return;
    setSalarySlips(salarySlips.filter(slip => slip.id !== id));
  };

  const handleSalarySlipMonthChange = (id, value) => {
    setSalarySlips(salarySlips.map(slip => 
      slip.id === id ? { ...slip, month: value } : slip
    ));
  };

  const handleSalarySlipFileChange = (id, e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setErrorModalMessage('Please upload only PDF, JPG or PNG files for salary slips');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setErrorModalMessage('Salary slip file size must be less than 5MB');
      setShowErrorModal(true);
      e.target.value = '';
      return;
    }

    setSalarySlips(salarySlips.map(slip => 
      slip.id === id ? { 
        ...slip, 
        file, 
        fileName: `Selected: ${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)` 
      } : slip
    ));
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const formatCurrency = (value) => {
    const numericValue = value.replace(/[^\d]/g, '');
    if (!numericValue) return '';
    return parseInt(numericValue).toLocaleString('en-IN');
  };

  const handleCurrencyChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = formatCurrency(value);
    setFormData(prev => ({ ...prev, [name]: formattedValue }));
  };

  const resetForm = () => {
    setFormData({
      fullName: '', 
      email: '', 
      mobile: '', 
      panCard: null,
      aadhaarFront: null,
      aadhaarBack: null,
      profilePhoto: null,
      position: '', 
      experience: '', 
      currentCompany: '', 
      currentCTC: '', 
      expectedCTC: '', 
      noticePeriod: '',
      coverLetter: '', 
      linkedin: '', 
      portfolio: '', 
      additionalDocuments: [],
      terms: false
    });
    setResumeFile(null);
    setProfilePhotoFile(null);
    setOfferLetterFile(null);
    setPanCardFile(null);
    setAadhaarFrontFile(null);
    setAadhaarBackFile(null);
    setProfilePhotoPreview('');
    setFileName('');
    setOfferLetterFileName('');
    setPanCardFileName('');
    setAadhaarFrontFileName('');
    setAadhaarBackFileName('');
    setAdditionalDocs([]);
    setSalarySlips([{ id: Date.now(), month: '', file: null, fileName: '' }]);
    setFormMessage({ text: '', type: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate mandatory fields
    if (!formData.fullName.trim()) {
      setErrorModalMessage('Full Name is required');
      setShowErrorModal(true);
      return;
    }
    
    if (!formData.email.trim()) {
      setErrorModalMessage('Email Address is required');
      setShowErrorModal(true);
      return;
    }
    
    if (!formData.mobile.trim() || formData.mobile.length !== 10) {
      setErrorModalMessage('Valid 10-digit Mobile Number is required');
      setShowErrorModal(true);
      return;
    }
    
    if (!formData.position.trim()) {
      setErrorModalMessage('Position Applying For is required');
      setShowErrorModal(true);
      return;
    }
    
    if (!resumeFile) {
      setErrorModalMessage('Resume upload is required');
      setShowErrorModal(true);
      return;
    }
    
    // Only validate terms checkbox
    if (!formData.terms) {
      setErrorModalMessage('Please agree to the terms and conditions');
      setShowErrorModal(true);
      return;
    }

    setLoading(true);

    // Prepare form data for API
    const submitData = new FormData();
    
    // Map form fields to API fields - all optional
    if (formData.fullName.trim()) submitData.append('name', formData.fullName);
    if (formData.email.trim()) submitData.append('email', formData.email);
    if (formData.mobile.trim()) submitData.append('mobile_number', formData.mobile);
    if (formData.position.trim()) submitData.append('position_applying_for', formData.position);
    if (formData.experience.trim()) submitData.append('total_experience_years', formData.experience);
    if (formData.currentCompany.trim()) submitData.append('current_company', formData.currentCompany);
    if (formData.currentCTC.trim()) submitData.append('current_ctc', formData.currentCTC.replace(/[^\d]/g, '') || '0');
    if (formData.expectedCTC.trim()) submitData.append('expected_ctc', formData.expectedCTC.replace(/[^\d]/g, '') || '0');
    if (formData.noticePeriod.trim()) submitData.append('notice_period', formData.noticePeriod);
    if (formData.coverLetter.trim()) submitData.append('cover_letter', formData.coverLetter);
    if (formData.linkedin.trim()) submitData.append('linkedin_profile', formData.linkedin);
    if (formData.portfolio.trim()) submitData.append('portfolio_website', formData.portfolio);
    submitData.append('agreed', formData.terms ? '1' : '0');
    
    // Append files if provided
    if (resumeFile) submitData.append('resume', resumeFile);
    if (profilePhotoFile) submitData.append('selfie', profilePhotoFile);
    if (offerLetterFile) submitData.append('other_documents[]', offerLetterFile);
    if (panCardFile) submitData.append('pan_card', panCardFile);
    if (aadhaarFrontFile) submitData.append('aadhar_card_front', aadhaarFrontFile);
    if (aadhaarBackFile) submitData.append('aadhar_card_back', aadhaarBackFile);
    
    // Append salary slips if provided
    salarySlips.forEach((slip, index) => {
      if (slip.file) {
        submitData.append(`salary_slips[${index}]`, slip.file);
      }
    });
    
    // Append additional documents if provided
    additionalDocs.forEach((doc, index) => {
      if (doc.file) {
        submitData.append(`other_documents[${index}][file]`, doc.file);
        submitData.append(`other_documents[${index}][document_type]`, doc.type || 'Other');
        submitData.append(`other_documents[${index}][document_name]`, doc.file.name);
      }
    });

    // Update the handleSubmit function's try-catch block:
try {
  const response = await fetch('https://kfs09.in/api/v1/job-seeker/register', {
    method: 'POST',
    body: submitData,
  });

  const result = await response.json();

  // Update the API error handling section:
if (response.ok) {
  setShowSuccessModal(true);
  resetForm();
} else {
  // Extract error message from response
  let errorMessage = 'Error submitting application. Please try again.';
  
  if (result.errors) {
    // Handle errors object like {email: ["The email has already been taken."]}
    const errorKeys = Object.keys(result.errors);
    if (errorKeys.length > 0) {
      // Get first error message
      const firstErrorKey = errorKeys[0];
      const firstError = result.errors[firstErrorKey];
      
      if (Array.isArray(firstError) && firstError.length > 0) {
        errorMessage = firstError[0]; // Get first error message from array
      } else if (typeof firstError === 'string') {
        errorMessage = firstError;
      } else {
        // Handle other error formats
        errorMessage = JSON.stringify(firstError);
      }
    }
  } else if (result.message) {
    errorMessage = result.message;
  } else if (result.error) {
    errorMessage = result.error;
  }
  
  setErrorModalMessage(errorMessage);
  setShowErrorModal(true);
  
  // Also log full error to console for debugging
  console.error('API Error Response:', {
    status: response.status,
    statusText: response.statusText,
    fullResponse: result
  });
}
} catch (error) {
  // Show network/JS error in modal
  const errorMessage = error.message || 'Network error. Please check your connection and try again.';
  setErrorModalMessage(errorMessage);
  setShowErrorModal(true);
  
  // Log full error to console
  console.error('Fetch Error:', error);
} finally {
  setLoading(false);
}
  };

  

  useEffect(() => {
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.career-benefit-card, .career-job-card, .career-info-card');
      elements.forEach(element => {
        const elementPosition = element.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.2;
        if (elementPosition < screenPosition) {
          element.style.opacity = '1';
          element.style.transform = 'translateY(0)';
        }
      });
    };

    const elements = document.querySelectorAll('.career-benefit-card, .career-job-card, .career-info-card');
    elements.forEach(element => {
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px)';
      element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    });

    window.addEventListener('load', animateOnScroll);
    window.addEventListener('scroll', animateOnScroll);
    setTimeout(animateOnScroll, 100);

    return () => {
      window.removeEventListener('load', animateOnScroll);
      window.removeEventListener('scroll', animateOnScroll);
    };
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <>

              {/* Mobile Sidebar Menu */}
      <div className={`mobile-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-sidebar-header">
          <div className="logo">
            <img 
              src="/images/kfs-logo.png" 
              alt="Finconcept Logo" 
              className="header-logo" 
            />
          </div>
          <button 
            className="mobile-close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            ×
          </button>
        </div>
        
        <div className="mobile-nav-links">
          <a href="/" onClick={() => setIsMobileMenuOpen(false)}>{t.navHome}</a>
          <a href="/#products" onClick={() => setIsMobileMenuOpen(false)}>{t.navProducts}</a>
          <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>{t.navAbout}</a> 
          <a href="/#dsa" onClick={() => setIsMobileMenuOpen(false)}>{t.navDsa}</a>
          <a href="/#faq" onClick={() => setIsMobileMenuOpen(false)}>{t.navFaq}</a>
          <a href="/#contact" onClick={() => setIsMobileMenuOpen(false)}>{t.navContact}</a>
          <a href="/career" onClick={() => setIsMobileMenuOpen(false)}>{t.navCareer}</a>
          <a href="/help" onClick={() => setIsMobileMenuOpen(false)}>{t.navHelp}</a>
        </div>
        
        <div className="mobile-nav-buttons">
          <button className="mobile-partner-btn">{t.partnerButton}</button>
          <button className="mobile-apply-btn">{t.applyButton}</button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="mobile-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Mobile Hamburger Menu Button */}
      <button 
        className="mobile-menu-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <header className="career-hero">
        <div className="career-hero-container">
          <div className="career-hero-content">
            <h1 className="career-hero-title">
              <span className="career-gradient-text">Build Your Future</span> With Krishna Finconcept
            </h1>
            <p className="career-hero-subtitle">
              Join India's fastest growing financial services platform. Grow your career with endless opportunities,
              industry-best training, and a culture that celebrates success.
            </p>

            <div className="career-hero-stats">
              <div className="career-stat-item">
                <div className="career-stat-number">150+</div>
                <div className="career-stat-label">Open Positions</div>
              </div>
              <div className="career-stat-item">
                <div className="career-stat-number">₹5L-₹25L</div>
                <div className="career-stat-label">Annual CTC Range</div>
              </div>
              <div className="career-stat-item">
                <div className="career-stat-number">4.8★</div>
                <div className="career-stat-label">Employee Rating</div>
              </div>
              <div className="career-stat-item">
                <div className="career-stat-number">50+</div>
                <div className="career-stat-label">Cities Across India</div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="career-why-join-section">
        <div className="career-container">
          <div className="career-section-header">
            <h2>Why Join Krishna Finconcept?</h2>
            <p>We offer more than just a job - we offer a career with purpose and growth</p>
          </div>

          <div className="career-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="career-benefit-card">
                <div className="career-benefit-icon">
                  <i className={benefit.icon}></i>
                </div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="career-openings-section">
        <div className="career-container">
          <div className="career-section-header">
            <h2>Current Open Positions</h2>
            <p>Explore exciting career opportunities across various departments</p>
          </div>

          <div className="career-department-tabs">
            {departments.map(dept => (
              <button
                key={dept.id}
                className={`career-tab-btn ${selectedDepartment === dept.id ? 'career-active' : ''}`}
                onClick={() => setSelectedDepartment(dept.id)}
              >
                {dept.name}
              </button>
            ))}
          </div>

          <div className="career-job-openings-grid">
            {filteredJobs.map(job => (
              <div key={job.id} className="career-job-card">
                <div className="career-job-tag">{job.tag}</div>
                <h3>{job.title}</h3>
                <div className="career-job-meta">
                  <span className="career-location"><i className="fas fa-map-marker-alt"></i> {job.location}</span>
                  <span className="career-experience"><i className="fas fa-briefcase"></i> {job.experience}</span>
                  <span className="career-salary"><i className="fas fa-rupee-sign"></i> {job.salary}</span>
                </div>
                <p className="career-job-description">{job.description}</p>
                <button className="career-apply-job-btn" onClick={() => handleApplyClick(job.title)}>
                  Apply Now
                </button>
              </div>
            ))}
          </div>

          <div className="career-load-more">
            <button className="career-view-all-btn" onClick={() => setSelectedDepartment('all')}>
              View All 150+ Positions <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </section>

      <section className="career-application-section">
        <div className="career-container">
          <div className="career-application-container">
            <div className="career-form-side">
              <div className="career-form-header">
                <h2>Apply for Position</h2>
                <p>Fill in your details to start your journey with Krishna Finconcept</p>
                <p className="career-form-required-note"><span style={{color: '#ef4444'}}>*</span> Required fields</p>
              </div>

              <form id="careerForm" className="career-career-form" onSubmit={handleSubmit}>
                {formMessage.text && (
                  <div className={`career-form-message ${formMessage.type === 'error' ? 'error api-error' : formMessage.type === 'success' ? 'api-success' : ''}`}>
                    {formMessage.text}
                  </div>
                )}

                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="fullName">Full Name <span style={{color: '#ef4444'}}>*</span></label>
                    <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleInputChange} placeholder="Enter your full name" />
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="email">Email Address <span style={{color: '#ef4444'}}>*</span></label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} placeholder="Enter your email address" />
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="mobile">Mobile Number <span style={{color: '#ef4444'}}>*</span></label>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        if (value.length <= 10) setFormData(prev => ({ ...prev, mobile: value }));
                      }}
                      placeholder="10-digit mobile number"
                      pattern="[0-9]{10}"
                      maxLength="10"
                    />
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="position">Position Applying For <span style={{color: '#ef4444'}}>*</span></label>
                    <select id="position" name="position" value={formData.position} onChange={handleInputChange}>
                      <option value="">Select Position</option>
                      <option value="Loan Sales Executive">Loan Sales Executive</option>
                      <option value="Relationship Manager">Relationship Manager</option>
                      <option value="Business Development Manager">Business Development Manager</option>
                      <option value="Operations Executive">Operations Executive</option>
                      <option value="Credit Analyst">Credit Analyst</option>
                      <option value="Customer Support Executive">Customer Support Executive</option>
                      <option value="Other">Other Position</option>
                    </select>
                  </div>
                </div>

                {/* PAN Card Upload */}
                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="panCard">PAN Card</label>
                    <div className="career-file-upload">
                      <input 
                        type="file" 
                        id="panCard" 
                        name="panCard" 
                        accept="image/*" 
                        onChange={handlePanCardChange}
                      />
                      <label htmlFor="panCard" className="career-file-label">
                        <i className="fas fa-id-card"></i>
                        <span className="career-file-text">Upload PAN Card</span>
                        <span className="career-file-size">Max 2MB</span>
                      </label>
                    </div>
                    {panCardFileName && <div className="career-file-name career-success">{panCardFileName}</div>}
                    <div className="career-file-note">
                      <small><i className="fas fa-info-circle"></i> Upload clear photo of your PAN card</small>
                    </div>
                  </div>
                </div>

                {/* Aadhaar Card Front & Back */}
                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="aadhaarFront">Aadhaar Card Front</label>
                    <div className="career-file-upload">
                      <input 
                        type="file" 
                        id="aadhaarFront" 
                        name="aadhaarFront" 
                        accept="image/*" 
                        onChange={handleAadhaarFrontChange}
                      />
                      <label htmlFor="aadhaarFront" className="career-file-label">
                        <i className="fas fa-address-card"></i>
                        <span className="career-file-text">Upload Aadhaar Front</span>
                        <span className="career-file-size">Max 2MB</span>
                      </label>
                    </div>
                    {aadhaarFrontFileName && <div className="career-file-name career-success">{aadhaarFrontFileName}</div>}
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="aadhaarBack">Aadhaar Card Back</label>
                    <div className="career-file-upload">
                      <input 
                        type="file" 
                        id="aadhaarBack" 
                        name="aadhaarBack" 
                        accept="image/*" 
                        onChange={handleAadhaarBackChange}
                      />
                      <label htmlFor="aadhaarBack" className="career-file-label">
                        <i className="fas fa-address-card"></i>
                        <span className="career-file-text">Upload Aadhaar Back</span>
                        <span className="career-file-size">Max 2MB</span>
                      </label>
                    </div>
                    {aadhaarBackFileName && <div className="career-file-name career-success">{aadhaarBackFileName}</div>}
                  </div>
                </div>
                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <div className="career-file-note">
                      <small><i className="fas fa-info-circle"></i> Upload clear photos of both front and back sides of your Aadhaar card</small>
                    </div>
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <label htmlFor="profilePhoto">Profile Photo</label>
                    <div className="career-photo-upload-container">
                      <div className="career-photo-preview">
                        {profilePhotoPreview ? (
                          <img src={profilePhotoPreview} alt="Profile Preview" />
                        ) : (
                          <div className="career-photo-placeholder">
                            <i className="fas fa-user"></i>
                          </div>
                        )}
                      </div>
                      <div className="career-photo-actions">
                        <button 
                          type="button" 
                          className="career-camera-btn"
                          onClick={captureFromCamera}
                        >
                          <i className="fas fa-camera"></i> Capture Profile Photo
                        </button>
                        {profilePhotoPreview && (
                          <button 
                            type="button" 
                            className="career-camera-btn career-cancel-btn"
                            onClick={() => {
                              setProfilePhotoPreview('');
                              setProfilePhotoFile(null);
                              setFormData(prev => ({ ...prev, profilePhoto: null }));
                            }}
                          >
                            <i className="fas fa-times"></i> Remove Photo
                          </button>
                        )}
                      </div>
                    </div>
                    {formData.profilePhoto && (
                      <div className="career-file-name career-success">
                        {formData.profilePhoto}
                      </div>
                    )}
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="experience">Total Experience</label>
                    <select id="experience" name="experience" value={formData.experience} onChange={handleInputChange}>
                      <option value="">Select Experience</option>
                      <option value="Fresher">Fresher (0-1 years)</option>
                      <option value="1-3">1-3 years</option>
                      <option value="3-5">3-5 years</option>
                      <option value="5-8">5-8 years</option>
                      <option value="8+">8+ years</option>
                    </select>
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="currentCompany">Current Company</label>
                    <input type="text" id="currentCompany" name="currentCompany" value={formData.currentCompany} onChange={handleInputChange} placeholder="Current company name" />
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="currentCTC">Current CTC (₹)</label>
                    <input type="text" id="currentCTC" name="currentCTC" value={formData.currentCTC} onChange={handleCurrencyChange} placeholder="e.g., 5,00,000" />
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="expectedCTC">Expected CTC (₹)</label>
                    <input type="text" id="expectedCTC" name="expectedCTC" value={formData.expectedCTC} onChange={handleCurrencyChange} placeholder="e.g., 7,00,000" />
                  </div>
                </div>

                {/* Salary Slips Section */}
                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <div className="career-salary-slips-header">
                      <label>Salary Slips (Last 6 Months)</label>
                      <button 
                        type="button" 
                        className="career-add-slip-btn"
                        onClick={() => addSalarySlip()}
                        disabled={salarySlips.length >= 6}
                      >
                        <i className="fas fa-plus"></i> Add Salary Slip
                      </button>
                    </div>
                    
                    {salarySlips.map((slip, index) => (
                      <div key={slip.id} className="career-salary-slip-item">
                        <div className="career-salary-slip-row">
                          <div className="career-form-group" style={{ flex: 1 }}>
                            <select 
                              value={slip.month}
                              onChange={(e) => handleSalarySlipMonthChange(slip.id, e.target.value)}
                            >
                              <option value="">Select Month</option>
                              <option value="January">January</option>
                              <option value="February">February</option>
                              <option value="March">March</option>
                              <option value="April">April</option>
                              <option value="May">May</option>
                              <option value="June">June</option>
                              <option value="July">July</option>
                              <option value="August">August</option>
                              <option value="September">September</option>
                              <option value="October">October</option>
                              <option value="November">November</option>
                              <option value="December">December</option>
                            </select>
                          </div>
                          <div className="career-form-group" style={{ flex: 2 }}>
                            <div className="career-file-upload">
                              <input 
                                type="file" 
                                id={`salarySlip-${slip.id}`}
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => handleSalarySlipFileChange(slip.id, e)}
                              />
                              <label htmlFor={`salarySlip-${slip.id}`} className="career-file-label">
                                <i className="fas fa-file-invoice"></i>
                                <span className="career-file-text">Upload Salary Slip</span>
                                <span className="career-file-size">Max 5MB</span>
                              </label>
                            </div>
                            {slip.fileName && <div className="career-file-name career-success">{slip.fileName}</div>}
                          </div>
                          {salarySlips.length > 1 && (
                            <button 
                              type="button" 
                              className="career-remove-slip-btn"
                              onClick={() => removeSalarySlip(slip.id)}
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                    
                    {salarySlips.length > 0 && (
                      <div className="career-file-note">
                        <small><i className="fas fa-info-circle"></i> Upload salary slips for last 6 months (PDF, JPG, PNG formats)</small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="noticePeriod">Notice Period</label>
                    <select id="noticePeriod" name="noticePeriod" value={formData.noticePeriod} onChange={handleInputChange}>
                      <option value="">Select Notice Period</option>
                      <option value="Immediate">Immediate Joining</option>
                      <option value="15">15 days</option>
                      <option value="30">30 days</option>
                      <option value="45">45 days</option>
                      <option value="60">60 days</option>
                      <option value="90">90 days</option>
                    </select>
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="resume">Upload Resume <span style={{color: '#ef4444'}}>*</span></label>
                    <div className="career-file-upload">
                      <input type="file" id="resume" name="resume" accept=".pdf,.doc,.docx" onChange={handleFileChange} />
                      <label htmlFor="resume" className="career-file-label">
                        <i className="fas fa-cloud-upload-alt"></i>
                        <span className="career-file-text">Choose file (PDF, DOC, DOCX)</span>
                        <span className="career-file-size">Max 5MB</span>
                      </label>
                    </div>
                    {fileName && <div className="career-file-name career-success">{fileName}</div>}
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <label htmlFor="offerLetter">Upload Offer Letter</label>
                    <div className="career-file-upload">
                      <input type="file" id="offerLetter" name="offerLetter" accept=".pdf,.doc,.docx" onChange={handleOfferLetterChange} />
                      <label htmlFor="offerLetter" className="career-file-label">
                        <i className="fas fa-file-contract"></i>
                        <span className="career-file-text">Choose offer letter file (PDF, DOC, DOCX)</span>
                        <span className="career-file-size">Max 5MB</span>
                      </label>
                    </div>
                    {offerLetterFileName && <div className="career-file-name career-success">{offerLetterFileName}</div>}
                    <div className="career-file-note">
                      <small><i className="fas fa-info-circle"></i> Upload your current or previous offer letter for reference</small>
                    </div>
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <label htmlFor="coverLetter">Cover Letter</label>
                    <textarea id="coverLetter" name="coverLetter" value={formData.coverLetter} onChange={handleInputChange} rows="4" placeholder="Tell us why you're interested..." />
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group">
                    <label htmlFor="linkedin">LinkedIn Profile</label>
                    <input type="url" id="linkedin" name="linkedin" value={formData.linkedin} onChange={handleInputChange} placeholder="https://linkedin.com/in/yourprofile" />
                  </div>
                  <div className="career-form-group">
                    <label htmlFor="portfolio">Portfolio/Website</label>
                    <input type="url" id="portfolio" name="portfolio" value={formData.portfolio} onChange={handleInputChange} placeholder="https://yourportfolio.com" />
                  </div>
                </div>

                {/* Additional Documents Section */}
                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <div className="career-additional-docs-header">
                      <label>Additional Documents</label>
                      <button 
                        type="button" 
                        className="career-add-doc-btn"
                        onClick={addAdditionalDocument}
                      >
                        <i className="fas fa-plus"></i> Add Document
                      </button>
                    </div>
                    
                    {additionalDocs.map((doc, index) => (
                      <div key={doc.id} className="career-additional-doc-item">
                        <div className="career-additional-doc-row">
                          <div className="career-form-group" style={{ flex: 1 }}>
                            <select 
                              value={doc.type}
                              onChange={(e) => handleAdditionalDocTypeChange(doc.id, e.target.value)}
                            >
                              <option value="">Select Document Type</option>
                              <option value="Experience Certificate">Experience Certificate</option>
                              <option value="Education Certificate">Education Certificate</option>
                              <option value="Salary Slip">Salary Slip</option>
                              <option value="PAN Card">PAN Card</option>
                              <option value="Aadhaar Card">Aadhaar Card</option>
                              <option value="Bank Statement">Bank Statement</option>
                              <option value="Other">Other Document</option>
                            </select>
                          </div>
                          <div className="career-form-group" style={{ flex: 2 }}>
                            <div className="career-file-upload">
                              <input 
                                type="file" 
                                id={`additionalDoc-${doc.id}`}
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                onChange={(e) => handleAdditionalDocFileChange(doc.id, e)}
                              />
                              <label htmlFor={`additionalDoc-${doc.id}`} className="career-file-label">
                                <i className="fas fa-cloud-upload-alt"></i>
                                <span className="career-file-text">Choose file</span>
                                <span className="career-file-size">Max 5MB</span>
                              </label>
                            </div>
                            {doc.fileName && <div className="career-file-name career-success">{doc.fileName}</div>}
                          </div>
                          <button 
                            type="button" 
                            className="career-remove-doc-btn"
                            onClick={() => removeAdditionalDocument(doc.id)}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                    
                    {additionalDocs.length > 0 && (
                      <div className="career-file-note">
                        <small><i className="fas fa-info-circle"></i> You can add multiple documents like experience certificates, education certificates, etc.</small>
                      </div>
                    )}
                  </div>
                </div>

                <div className="career-form-row">
                  <div className="career-form-group career-full-width">
                    <div className="career-checkbox-group">
                      <input type="checkbox" id="terms" name="terms" checked={formData.terms} onChange={handleInputChange} required />
                      <label htmlFor="terms">
                        I agree to the <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and consent to being contacted for recruitment purposes
                      </label>
                    </div>
                  </div>
                </div>

                <button type="submit" className="career-submit-btn" disabled={loading}>
                  <i className={loading ? "fas fa-spinner fa-spin" : "fas fa-paper-plane"}></i>
                  {loading ? 'Submitting...' : 'Submit Application'}
                </button>
              </form>
            </div>

            <div className="career-info-side">
              <div className="career-info-card">
                <h3><i className="fas fa-headset"></i> HR Contact</h3>
                <div className="career-contact-info">
                  <p><i className="fas fa-envelope"></i> hr@krishnafinconcept.com</p>
                  <p><i className="fas fa-phone"></i> 9909002220</p>
                  <p><i className="fas fa-clock"></i> Mon-Fri, 10 AM - 6 PM</p>
                </div>
              </div>

              <div className="career-info-card">
                <h3><i className="fas fa-lightbulb"></i> Application Tips</h3>
                <ul className="career-tips-list">
                  <li><i className="fas fa-check-circle"></i> Update your resume with recent experience</li>
                  <li><i className="fas fa-check-circle"></i> Customize cover letter for the position</li>
                  <li><i className="fas fa-check-circle"></i> Highlight relevant achievements</li>
                  <li><i className="fas fa-check-circle"></i> Ensure contact details are correct</li>
                  <li><i className="fas fa-check-circle"></i> Mention notice period clearly</li>
                </ul>
              </div>

              <div className="career-info-card">
                <h3><i className="fas fa-history"></i> Hiring Process</h3>
                <div className="career-process-timeline">
                  <div className="career-process-step">
                    <div className="career-step-number">1</div>
                    <div className="career-step-content">
                      <h4>Application Review</h4>
                      <p>3-5 working days</p>
                    </div>
                  </div>
                  <div className="career-process-step">
                    <div className="career-step-number">2</div>
                    <div className="career-step-content">
                      <h4>HR Screening</h4>
                      <p>Telephonic interview</p>
                    </div>
                  </div>
                  <div className="career-process-step">
                    <div className="career-step-number">3</div>
                    <div className="career-step-content">
                      <h4>Technical Interview</h4>
                      <p>With department head</p>
                    </div>
                  </div>
                  <div className="career-process-step">
                    <div className="career-step-number">4</div>
                    <div className="career-step-content">
                      <h4>Final Offer</h4>
                      <p>Offer letter & onboarding</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="career-info-card">
                <h3><i className="fas fa-question-circle"></i> FAQs</h3>
                <div className="career-faq-item">
                  <p><strong>How long does the hiring process take?</strong></p>
                  <p>Typically 2-3 weeks from application to offer.</p>
                </div>
                <div className="career-faq-item">
                  <p><strong>Do you provide training?</strong></p>
                  <p>Yes, comprehensive training is provided for all roles.</p>
                </div>
                <div className="career-faq-item">
                  <p><strong>Is remote work available?</strong></p>
                  <p>Selected positions offer remote/hybrid options.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showSuccessModal && (
        <div className="career-modal" style={{ display: 'flex' }}>
          <div className="career-modal-content">
            <div className="career-modal-icon">
              <i className="fas fa-check-circle"></i>
            </div>
            <h3>Application Submitted Successfully!</h3>
            <p>Thank you {formData.fullName}! Your application for {formData.position} has been submitted successfully. Our HR team will contact you within 3-5 working days.</p>
            <div className="career-modal-actions">
              <button onClick={() => setShowSuccessModal(false)} className="career-modal-btn">Close</button>
              <button onClick={() => navigate('/')} className="career-modal-btn career-secondary">Back to Home</button>
            </div>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {showErrorModal && (
  <div className="career-modal" style={{ display: 'flex' }}>
    <div className="career-modal-content" style={{ maxWidth: '500px' }}>
      <div className="career-modal-icon" style={{ color: '#ef4444' }}>
        <i className="fas fa-exclamation-triangle"></i>
      </div>
      <h3>Oops! Something Went Wrong</h3>
      <p style={{ color: '#64748b', lineHeight: '1.6', marginBottom: '10px' }}>
        {errorModalMessage}
      </p>
      <p style={{ fontSize: '0.85rem', color: '#94a3b8', fontStyle: 'italic' }}>
       
      </p>
      <div className="career-modal-actions">
        <button 
          onClick={() => setShowErrorModal(false)} 
          className="career-modal-btn"
          style={{ background: '#ef4444', borderColor: '#ef4444', color: 'white' }}
        >
          <i className="fas fa-times"></i> Close
        </button>
      </div>
    </div>
  </div>
)}


          {/* ========== ADD FOOTER HERE ========== */}
      {/* <footer>
        <div className="footer-content">
          <div className="footer-section">
            <h4>Krishna Finconcept Services</h4>
            <p>India's leading financial services platform, connecting customers with 100+ banking partners for loans, credit cards, insurance and investment products.</p>
            <div className="social-icons">
              <button className="social-icon">f</button>
              <button className="social-icon">t</button>
              <button className="social-icon">in</button>
              <button className="social-icon">ig</button>
            </div>
          </div>
          <div className="footer-section">
            <h4>Loan Products</h4>
            <ul className="footer-links">
              <li><button className="footer-link" onClick={() => navigate('/home-loan')}>Home Loan</button></li>
              <li><button className="footer-link" onClick={() => navigate('/personal-loan')}>Personal Loan</button></li>
              <li><button className="footer-link" onClick={() => navigate('/business-loan')}>Business Loan</button></li>
              <li><button className="footer-link" onClick={() => navigate('/loan-against-property')}>Loan Against Property</button></li>
              <li><button className="footer-link" onClick={() => navigate('/car-loan')}>Car Loan</button></li>
              <li><button className="footer-link" onClick={() => navigate('/education-loan')}>Education Loan</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Other Services</h4>
            <ul className="footer-links">
              <li><button className="footer-link">Credit Cards</button></li>
              <li><button className="footer-link">Insurance</button></li>
              <li><button className="footer-link">Gold Loan</button></li>
              <li><button className="footer-link">Bill Payments</button></li>
              <li><button className="footer-link">Free Credit Score</button></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><button className="footer-link" onClick={() => navigate('/')}>Become Partner</button></li>
              <li><button className="footer-link" onClick={() => navigate('/#contact')}>Contact Us</button></li>
              <li><button className="footer-link" onClick={() => navigate('/career')}>Career with us</button></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          © {new Date().getFullYear()} Krishna Finconcept Services. All rights reserved.
        </div>
      </footer> */}
      {/* ========== END FOOTER ========== */}


    </>
  );
};

export default Career;